module.exports = __webpack_public_path__ + "static/media/pic-sl7.d4cd8abe.png";